import { createApp } from "vue";
import { createPinia } from "pinia";
import PrimeVue from "primevue/config";

import "@fontsource/sora/600.css";
import "@fontsource/sora/700.css";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/500.css";
import "@fontsource/figtree/600.css";
import "@fontsource/jetbrains-mono/500.css";
import "./theme/tokens.css";

import App from "./App.vue";
import { installUnauthorizedRedirect } from "./api";
import { installAutocompleteGuard } from "./autocomplete";
import { appliquerLangue, creerI18n, localeInitiale } from "./locales/index";
import { createAppRouter } from "./router";
import { DARK_MODE_SELECTOR, portalPreset } from "./theme/preset";
import { poserTheme, themeInitial } from "./theme/index";

poserTheme(themeInitial());
appliquerLangue(localeInitiale());

const router = createAppRouter();
installUnauthorizedRedirect(router);

createApp(App)
  .use(createPinia())
  .use(router)
  .use(creerI18n())
  .use(PrimeVue, {
    license: __PRIMEUI_LICENSE__,
    theme: {
      preset: portalPreset,
      options: { darkModeSelector: DARK_MODE_SELECTOR },
    },
  })
  .mount("#app");

// PrimeVue overlays are teleported to <body>: the guard watches the whole body, not just #app
installAutocompleteGuard(document.body);
